import MockInterviewSEO from '../components/seo/MockInterviewSEO';
import MockInterviewHero from '../components/MockInterviewHero';
import BenefitsSection from '../components/BenefitsSection';
import InterviewProcessSection from '../components/InterviewProcessSection';
import PricingPlans from '../components/PricingPlans';
import FAQSection from '../components/FAQSection';
import backgroundImage from '../static/background.png';

const MockInterview = () => {
  return (
    <main className="min-h-screen bg-gray-50">
      <MockInterviewSEO />

      {/* Hero Section with Background Image */}
      <div
        className="relative overflow-hidden"
        style={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-40"></div>
        <div className="relative z-10">
          <MockInterviewHero />
        </div>
      </div>

      {/* Benefits - Why Mock Interviews */}
      <BenefitsSection />

      {/* How It Works */}
      <InterviewProcessSection />

      {/* Pricing Section */}
      <div id="pricing-section" className="py-10 bg-gradient-to-br from-gray-50 to-orange-50">
        <div className="container mx-auto max-w-7xl px-4">
          <PricingPlans />
        </div>
      </div>

      {/* FAQ Section */}
      <FAQSection />
    </main>
  );
};

export default MockInterview;
